module.exports = __webpack_public_path__ + "img/Wp_2009.71337eec.png";